<template>
  <button
      :disabled="loading || disabled"
      @click="$emit('click')"
  >
    <template v-if="loading">
      <svg
          style="animation: spin 1s linear infinite; width: 1em; height: 1em; vertical-align: middle; margin-right: 0.5em;"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
      >
        <circle
            cx="12" cy="12" r="10"
            stroke="currentColor"
            stroke-opacity="0.25"
            stroke-width="4"
        />
        <path
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        />
      </svg>
      Loading...
    </template>
    <template v-else>
      <slot>Start</slot>
    </template>
  </button>
</template>

<script setup>
const emit = defineEmits(['click'])

const props = defineProps({
  loading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
})
</script>